import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { clearFulfillmentView } from "./viewPersistence";

export default function FulfillmentRouteState() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.replace(/\/+$/, "") !== "/order-fulfillment") clearFulfillmentView();
  }, [pathname]);
  return null;
}
